// Static product data mirror (for frontend rendering). Source of truth = backend.
export const PRODUCTS = [
  {
    id: "engorde-complet",
    slug: "engorde-complet-npk-6-5-43",
    image: "https://i.imgur.com/ARlrl1i.png",
    npk: "NPK 6-5-43",
    category: { es: "Fertilizante", en: "Fertilizer" },
    name: { es: "Engorde Complet NPK 6-5-43", en: "Engorde Complet NPK 6-5-43" },
    tagline: {
      es: "Calidad, engorde y maduración del fruto",
      en: "Quality, fattening and fruit ripening",
    },
    description: {
      es: "Abono NPK 6-5-43 con micronutrientes diseñado para incrementar calidad, mejorar el engorde y densidad del fruto, facilitar la síntesis de proteínas y almidón (incrementando °Brix) y favorecer la maduración del fruto acentuando la coloración sin disminuir la vida postcosecha.",
      en: "NPK 6-5-43 fertilizer with micronutrients designed to increase quality, improve fruit fattening and density, facilitate protein and starch synthesis (increasing °Brix), and promote fruit ripening by enhancing coloration without reducing post-harvest life.",
    },
    benefits: {
      es: [
        "Aumento de calidad y densidad del fruto",
        "Mayor contenido de azúcares (°Brix)",
        "Coloración intensa y maduración uniforme",
        "Activa la respiración celular y enzimas",
        "Distribución eficiente de fotoasimilados",
      ],
      en: [
        "Increased fruit quality and density",
        "Higher sugar content (°Brix)",
        "Intense coloration and uniform ripening",
        "Activates cellular respiration and enzymes",
        "Efficient distribution of photoassimilates",
      ],
    },
    composition: [
      { label: "N total", value: "6.0%" },
      { label: "P₂O₅", value: "5.0%" },
      { label: "K₂O", value: "43.0%" },
      { label: "Fe (EDTA)", value: "0.63%" },
      { label: "Mn (EDTA)", value: "0.32%" },
      { label: "Zn (EDTA)", value: "0.06%" },
      { label: "B", value: "0.06%" },
      { label: "Cu (EDTA)", value: "0.02%" },
      { label: "Mo", value: "0.04%" },
    ],
    dosage: {
      foliar: { es: "300-600 g/hl según cultivo", en: "300-600 g/hl by crop" },
      fertigation: { es: "3-10 kg/ha según cultivo", en: "3-10 kg/ha by crop" },
    },
    crops: {
      es: ["Cítricos y frutales", "Hortícolas", "Flores y ornamentales", "Frutales tropicales", "Olivos y vides", "Herbáceos y leñosos"],
      en: ["Citrus and fruit trees", "Vegetables", "Flowers and ornamentals", "Tropical fruits", "Olive trees and vines", "Herbaceous and woody crops"],
    },
  },
  {
    id: "nautic",
    slug: "nautic",
    image: "https://i.imgur.com/C92Bh0F.png",
    npk: "ALGA + AA",
    category: { es: "Bioestimulante", en: "Biostimulant" },
    name: { es: "Nautic", en: "Nautic" },
    tagline: {
      es: "Algas Ascophyllum Nodosum + Aminoácidos vegetales",
      en: "Ascophyllum Nodosum algae + plant-based amino acids",
    },
    description: {
      es: "Fertilizante con alto contenido en macroalgas (Ascophyllum Nodosum) y aminoácidos vegetales que apoya a la planta en enraizamiento, crecimiento, producción y resistencia a estrés biótico y abiótico, prolongando la vida útil del fruto.",
      en: "Fertilizer with high content of macroalgae (Ascophyllum Nodosum) and plant-derived amino acids supporting rooting, growth, production and resistance to biotic and abiotic stress, while extending fruit shelf life.",
    },
    benefits: {
      es: [
        "Estimula la producción hormonal natural",
        "Mejora absorción y traslocación de nutrientes",
        "Retrasa la senescencia",
        "Mayor resistencia a hongos y bacterias",
        "Adaptación a condiciones de estrés",
      ],
      en: [
        "Stimulates natural hormone production",
        "Improves nutrient absorption and translocation",
        "Delays senescence",
        "Greater resistance to fungi and bacteria",
        "Adaptation to stress conditions",
      ],
    },
    composition: [
      { label: "N total", value: "4%" },
      { label: "N orgánico", value: "4%" },
      { label: "P₂O₅", value: "3%" },
      { label: "K₂O", value: "3%" },
      { label: "Ácido Algínico", value: "5%" },
      { label: "Manitol", value: "1%" },
      { label: "Aminoácidos Libres", value: "50%" },
      { label: "Ascophyllum Nodosum", value: "50%" },
    ],
    dosage: {
      foliar: { es: "500-1000 g/hl", en: "500-1000 g/hl" },
      fertigation: { es: "1000-2000 g/ha", en: "1000-2000 g/ha" },
    },
    crops: {
      es: ["Apto agricultura ecológica (CE 834/2007)", "Todos los cultivos"],
      en: ["Suitable for organic farming (EC 834/2007)", "All crops"],
    },
  },
  {
    id: "nuster-flower",
    slug: "nuster-flower-npk-14-40-5",
    image: "https://i.imgur.com/tQmQdPr.png",
    npk: "NPK 14-40-5",
    category: { es: "Floración / Cuaje", en: "Flowering / Fruit set" },
    name: { es: "Nuster Flower NPK 14-40-5", en: "Nuster Flower NPK 14-40-5" },
    tagline: {
      es: "Floración y cuaje con azufre y microelementos quelatados",
      en: "Flowering and fruit set with sulfur and chelated micros",
    },
    description: {
      es: "Solución NPK 14-40-5 con azufre (SO₃) y microelementos quelatados: Cu, Fe, Mo y Zn. Favorece floración y cuaje del fruto en cultivos exigentes.",
      en: "NPK 14-40-5 solution with sulfur (SO₃) and chelated micronutrients: Cu, Fe, Mo and Zn. Promotes flowering and fruit set in demanding crops.",
    },
    benefits: {
      es: [
        "Estimula floración intensa",
        "Mejora el cuaje del fruto",
        "Aporte equilibrado de fósforo y azufre",
        "100% quelatado por EDTA",
        "Estabilidad en rango pH 3-8",
      ],
      en: [
        "Stimulates intense flowering",
        "Improves fruit set",
        "Balanced phosphorus and sulfur contribution",
        "100% chelated by EDTA",
        "Stability across pH range 3-8",
      ],
    },
    composition: [
      { label: "N total", value: "14%" },
      { label: "P₂O₅", value: "40%" },
      { label: "K₂O", value: "5%" },
      { label: "SO₃", value: "13%" },
      { label: "Fe (EDTA)", value: "0.1%" },
      { label: "Zn (EDTA)", value: "0.1%" },
      { label: "Cu", value: "0.05%" },
      { label: "Mo", value: "0.01%" },
    ],
    dosage: {
      foliar: { es: "200-300 g/hl", en: "200-300 g/hl" },
      fertigation: { es: "5-10 kg/ha", en: "5-10 kg/ha" },
    },
    crops: {
      es: ["Cítricos y frutales", "Hortícolas", "Vid", "Ornamentales"],
      en: ["Citrus and fruit trees", "Vegetables", "Vineyard", "Ornamentals"],
    },
  },
  {
    id: "hierro-6-48",
    slug: "hierro-6-48",
    image: "https://i.imgur.com/yKmWQMp.png",
    npk: "Fe 6% EDDHA",
    category: { es: "Microelemento", en: "Micronutrient" },
    name: { es: "Hierro 6-48", en: "Hierro 6-48" },
    tagline: {
      es: "Corrector de clorosis férrica de alta eficacia",
      en: "High-efficacy iron chlorosis corrector",
    },
    description: {
      es: "Nuevo quelato de hierro en microgránulos finos que aporta la cantidad necesaria para corregir la clorosis férrica. Altamente soluble en agua y de fácil absorción radicular.",
      en: "New iron chelate in fine microgranules providing the necessary amount to correct iron chlorosis. Highly water soluble and easily absorbed by roots.",
    },
    benefits: {
      es: [
        "Corrige rápidamente la clorosis férrica",
        "Restaura la producción de clorofila",
        "Apto para riego por goteo",
        "Microgránulos de alta solubilidad",
        "Tratamientos preventivos a baja dosis",
      ],
      en: [
        "Rapidly corrects iron chlorosis",
        "Restores chlorophyll production",
        "Suitable for drip irrigation",
        "Highly soluble microgranules",
        "Preventive treatments at low dosage",
      ],
    },
    composition: [
      { label: "Fe soluble", value: "6%" },
      { label: "Fracción Orto-Orto", value: "4.8%" },
      { label: "Quelante", value: "EDDHA" },
    ],
    dosage: {
      foliar: { es: "150-200 cc/100L", en: "150-200 cc/100L" },
      fertigation: { es: "25-110 g/árbol", en: "25-110 g/tree" },
    },
    crops: {
      es: ["Frutales y cítricos", "Vid y parral", "Hortalizas", "Viveros y ornamentales"],
      en: ["Fruit trees and citrus", "Vines and trellis", "Vegetables", "Nurseries and ornamentals"],
    },
  },
  {
    id: "molibdeno-eco",
    slug: "molibdeno-eco",
    image: "https://i.imgur.com/gwFahrM.png",
    npk: "Mo + B + P + K",
    category: { es: "Corrector", en: "Corrector" },
    name: { es: "Molibdeno Eco", en: "Molibdeno Eco" },
    tagline: {
      es: "Corrector de Boro, Molibdeno, Fósforo y Potasio",
      en: "Boron, Molybdenum, Phosphorus and Potassium corrector",
    },
    description: {
      es: "Mezcla sólida de micronutrientes minerales en polvo soluble. Aporta el equilibrio perfecto de Boro, Molibdeno, Fósforo y Potasio, altamente solubles para la planta.",
      en: "Solid mixture of mineral micronutrients in soluble powder. Delivers the perfect balance of Boron, Molybdenum, Phosphorus and Potassium, highly plant-soluble.",
    },
    benefits: {
      es: [
        "Equilibra nutrientes esenciales",
        "Mejora nutrición integral",
        "Favorece floración y cuaje",
        "Polvo soluble de rápida absorción",
        "Compatible con riego y foliar",
      ],
      en: [
        "Balances essential nutrients",
        "Improves comprehensive nutrition",
        "Promotes flowering and fruit set",
        "Quickly absorbed soluble powder",
        "Compatible with irrigation and foliar",
      ],
    },
    composition: [
      { label: "P₂O₅", value: "8%" },
      { label: "K₂O", value: "8%" },
      { label: "B", value: "8%" },
      { label: "Mo", value: "10%" },
      { label: "pH (1%)", value: "6" },
    ],
    dosage: {
      foliar: { es: "150-300 g/hl", en: "150-300 g/hl" },
      fertigation: { es: "2-5 kg/ha", en: "2-5 kg/ha" },
    },
    crops: {
      es: ["Cítricos y frutales", "Hortícolas", "Flores y ornamentales", "Frutales tropicales"],
      en: ["Citrus and fruit trees", "Vegetables", "Flowers and ornamentals", "Tropical fruits"],
    },
  },
  {
    id: "algas-marinas-plus",
    slug: "algas-marinas-plus",
    image: "https://i.imgur.com/y7EF0KB.png",
    npk: "ALGA + K",
    category: { es: "Abono orgánico mineral", en: "Organic mineral fertilizer" },
    name: { es: "Algas Marinas Plus", en: "Marine Algae Plus" },
    tagline: { es: "Algas Ascophyllum Nodosum frescas en costa", en: "Ascophyllum Nodosum algae fresh-harvested on the coast" },
    description: {
      es: "Abono orgánico mineral sólido formulado a partir de algas cosechadas, seleccionadas y procesadas en la misma línea de costa para mantener la máxima frescura y vigor de su material bioactivo. El ácido algínico y los nutrientes mejoran la respuesta del cultivo ante condiciones adversas.",
      en: "Solid organic-mineral fertilizer formulated from algae harvested, selected and processed on the coastline to preserve maximum freshness and vigor of bioactive material. Alginic acid and nutrients improve crop response to adverse conditions.",
    },
    benefits: {
      es: ["Mejora la respuesta del cultivo ante estrés", "Mantiene la frescura del material bioactivo", "Aporta nutrientes vía ácido algínico", "Estimula el desarrollo radicular", "Compatible con la mayoría de programas nutricionales"],
      en: ["Improves crop stress response", "Preserves bioactive material freshness", "Delivers nutrients via alginic acid", "Stimulates root development", "Compatible with most nutrition programs"],
    },
    composition: [
      { label: "Ascophyllum Nodosum", value: "100%" },
      { label: "Manitol", value: "3.5%" },
      { label: "Ácido Algínico", value: "14%" },
      { label: "K₂O soluble", value: "2.15%" },
    ],
    dosage: {
      foliar: { es: "120-150 g/100 L. Disolver en agua caliente y reposar 48h.", en: "120-150 g/100 L. Dissolve in hot water and rest 48h." },
      fertigation: { es: "Frutales/viñedo: 500 g-1.5 kg/ha · Hortícolas/plátano: 500 g/ha · Cereales: 150-350 g/ha", en: "Fruit/vineyard: 500 g-1.5 kg/ha · Vegetables/banana: 500 g/ha · Cereals: 150-350 g/ha" },
    },
    crops: {
      es: ["Uva de mesa y viñedo", "Patata", "Frutales y cítricos", "Plátano", "Hortícolas", "Cereales y arroz", "Alfalfa y praderas", "Árboles jóvenes"],
      en: ["Table grape and vineyard", "Potato", "Fruit trees and citrus", "Banana", "Vegetables", "Cereals and rice", "Alfalfa and pastures", "Young trees"],
    },
  },
  {
    id: "nedeska-plus",
    slug: "nedeska-plus",
    image: "https://i.imgur.com/FPNK7IG.png",
    npk: "BIO · P. lilacinus",
    category: { es: "Bioprotector", en: "Bioprotectant" },
    name: { es: "Nedeska Plus", en: "Nedeska Plus" },
    tagline: { es: "Control biológico de nemátodos en suelo", en: "Biological soil nematode control" },
    description: {
      es: "Material biológico para el control de nemátodos y la protección de las raíces. El ingrediente activo Paecilomyces lilacinus es un agente de control biológico que protege las raíces frente a los nemátodos.",
      en: "Biological material for nematode control and root protection. The active ingredient Paecilomyces lilacinus is a biocontrol agent that protects roots against nematodes.",
    },
    benefits: {
      es: ["Control biológico de nemátodos", "Protege el sistema radicular", "Apto para manejo integrado de plagas", "Compatible con agricultura sostenible", "Amplio espectro de cultivos"],
      en: ["Biological nematode control", "Protects the root system", "Suitable for IPM", "Compatible with sustainable agriculture", "Broad crop spectrum"],
    },
    composition: [
      { label: "Paecilomyces lilacinus", value: "100%" },
      { label: "pH", value: "5.5 - 8.5" },
    ],
    dosage: {
      foliar: { es: "Aplicación al suelo", en: "Soil application" },
      fertigation: { es: "1 kg/ha vía riego", en: "1 kg/ha via irrigation" },
    },
    crops: {
      es: ["Cereales", "Frutales de hueso y frutales", "Hortalizas y legumbres", "Olivos", "Plantas ornamentales", "Viñas"],
      en: ["Cereals", "Stone fruits and fruit trees", "Vegetables and legumes", "Olive trees", "Ornamentals", "Vineyards"],
    },
  },
  {
    id: "fks-plus-20-20-20",
    slug: "fks-plus-npk-20-20-20",
    image: "https://i.imgur.com/B9iWzkX.png",
    npk: "NPK 20-20-20",
    category: { es: "Fertilizante soluble", en: "Soluble fertilizer" },
    name: { es: "FKS Plus NPK 20-20-20", en: "FKS Plus NPK 20-20-20" },
    tagline: { es: "Equilibrado para crecimiento y engorde", en: "Balanced for growth and fattening" },
    description: {
      es: "Fertilizante NPK 20-20-20 totalmente soluble con micronutrientes quelatados. Aporta nitrógeno, fósforo y potasio en partes iguales junto a microelementos esenciales para el desarrollo equilibrado del cultivo.",
      en: "Fully soluble NPK 20-20-20 fertilizer with chelated micronutrients. Provides balanced N-P-K plus essential micronutrients for balanced crop development.",
    },
    benefits: {
      es: ["N-P-K en partes iguales", "Microelementos quelatados (EDTA)", "Solubilidad total en agua", "Promueve crecimiento y engorde", "Ideal para fertirriego"],
      en: ["Balanced N-P-K", "EDTA-chelated micronutrients", "Full water solubility", "Promotes growth and fattening", "Ideal for fertigation"],
    },
    composition: [
      { label: "N total", value: "20%" },
      { label: "P₂O₅", value: "20%" },
      { label: "K₂O", value: "20%" },
      { label: "Mo", value: "0.04%" },
      { label: "B", value: "0.013%" },
      { label: "Fe (EDTA)", value: "0.04%" },
      { label: "Zn", value: "0.04%" },
      { label: "Mn (EDTA)", value: "0.014%" },
    ],
    dosage: {
      foliar: { es: "200-400 g/hl según cultivo", en: "200-400 g/hl by crop" },
      fertigation: { es: "10 kg/ha y semana", en: "10 kg/ha per week" },
    },
    crops: {
      es: ["Todos los cultivos", "Cítricos y frutales", "Hortícolas", "Ornamentales"],
      en: ["All crops", "Citrus and fruit trees", "Vegetables", "Ornamentals"],
    },
  },
  {
    id: "cuak-g-10",
    slug: "cuak-g-10",
    image: "https://i.imgur.com/CBAxaJI.png",
    npk: "MO 40% · HUM",
    category: { es: "Enmienda húmica", en: "Humic amendment" },
    name: { es: "Cuak G-10", en: "Cuak G-10" },
    tagline: { es: "Materia orgánica con ácidos húmicos y fúlvicos", en: "Organic matter with humic and fulvic acids" },
    description: {
      es: "Enmienda orgánica granulada con alta concentración de materia orgánica y extracto húmico total. Mejora estructura del suelo, retención de agua y absorción de nutrientes.",
      en: "Granulated organic amendment with high organic matter and total humic extract. Improves soil structure, water retention and nutrient uptake.",
    },
    benefits: {
      es: ["Mejora estructura del suelo", "Aumenta retención de agua", "Optimiza absorción de nutrientes", "Ácidos húmicos y fúlvicos", "Compatible con la mayoría de fertilizantes"],
      en: ["Improves soil structure", "Increases water retention", "Optimizes nutrient uptake", "Humic and fulvic acids", "Compatible with most fertilizers"],
    },
    composition: [
      { label: "N orgánico", value: "3.0%" },
      { label: "K₂O total", value: "3.0%" },
      { label: "Materia orgánica", value: "40.0%" },
      { label: "Carbono orgánico", value: "35.0%" },
      { label: "Ácidos húmicos", value: "17.0%" },
      { label: "Ácidos fúlvicos", value: "11.5%" },
      { label: "Extracto húmico", value: "28.5%" },
      { label: "C.E.", value: "2.6 dS/m" },
    ],
    dosage: {
      foliar: { es: "No aplicar por vía foliar", en: "Not for foliar application" },
      fertigation: { es: "10-18 kg/ha en 1-3 aplicaciones. Diluir 1-3% (1-3 kg/100L).", en: "10-18 kg/ha in 1-3 applications. Dilute 1-3% (1-3 kg/100L)." },
    },
    crops: {
      es: ["Hortícolas", "Frutales", "Cítricos"],
      en: ["Vegetables", "Fruit trees", "Citrus"],
    },
  },
  {
    id: "microelementos",
    slug: "microelementos",
    image: "https://i.imgur.com/3zTjKSV.png",
    npk: "MIX · 7 MICROS",
    category: { es: "Microelementos", en: "Micronutrient mix" },
    name: { es: "Microelementos", en: "Microelements" },
    tagline: { es: "7 microelementos quelatados de alta disponibilidad", en: "7 chelated micronutrients with high availability" },
    description: {
      es: "Mezcla completa de microelementos esenciales en forma quelatada para máxima disponibilidad. Estable en pH 3-9. Mejora coloración, vigor y resistencia del cultivo.",
      en: "Complete mix of essential micronutrients in chelated form for maximum availability. Stable pH 3-9. Improves coloration, vigor and crop resistance.",
    },
    benefits: {
      es: ["7 micronutrientes esenciales", "Forma quelatada (EDTA)", "Mejora coloración y vigor", "Aumenta resistencia a estrés", "Amplio rango de cultivos"],
      en: ["7 essential micronutrients", "EDTA-chelated", "Improves coloration and vigor", "Increases stress resistance", "Wide crop range"],
    },
    composition: [
      { label: "B", value: "3.0%" },
      { label: "Cu (EDTA)", value: "4.0%" },
      { label: "Fe (EDTA)", value: "6.0%" },
      { label: "Mn (EDTA)", value: "5.0%" },
      { label: "MgO (EDTA)", value: "5.0%" },
      { label: "Mo", value: "5.0%" },
      { label: "Zn (EDTA)", value: "5.0%" },
      { label: "Estabilidad pH", value: "3-9" },
    ],
    dosage: {
      foliar: { es: "Flor/hortícolas: 20-50 g/hl · Frutales: 50-100 g/hl. 2-4 tratamientos.", en: "Flower/vegetables: 20-50 g/hl · Fruit: 50-100 g/hl. 2-4 treatments." },
      fertigation: { es: "Ornamentales: 30-50 g/100L · Hortícolas: 50-150 g/1000 m² · Frutales: 6.4-7.5 kg/ha", en: "Ornamentals: 30-50 g/100L · Vegetables: 50-150 g/1000 m² · Fruit: 6.4-7.5 kg/ha" },
    },
    crops: {
      es: ["Cultivos ornamentales y de flor", "Hortícolas", "Frutales y cítricos"],
      en: ["Ornamentals and flowers", "Vegetables", "Fruit trees and citrus"],
    },
  },
];
